export const STATUS_CONFIG = {
  upcoming:  { label: "Em breve", bg: "#FEEDB4", text: "#65541B", dot: "#B2911E", gradient: "linear-gradient(135deg, #B2911E, #65541B)" },
  live:      { label: "Ao vivo",  bg: "#00DCA4", text: "#003326", dot: "#003326", gradient: "linear-gradient(135deg, #00DCA4, #008572)" },
  recording: { label: "Gravação", bg: "#EAFAF6", text: "#00664C", dot: "#00664C", gradient: "linear-gradient(135deg, #00664C, #003326)" },
};

export const CATEGORIES = [
  "Masterclass",
  "Workshop",
  "Talk de Carreira",
  "Oficina",
];

export const CATEGORY_COLORS = {
  "Masterclass":            { bg: "#B0FCEA", text: "#003326" },
  "Workshop":               { bg: "#D5F9D7", text: "#008572" },
  "Talk de Carreira":       { bg: "#D4E4FF", text: "#1E3A6E" },
  "Oficina":                { bg: "#D4F5ED", text: "#00664C" },
};
